import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGeoAccess } from '../context/GeoAccessContext';

export default function GeoBlockedPage() {
  const { t } = useTranslation();
  const { decision } = useGeoAccess();
  const country = decision?.country ? String(decision.country) : null;
  const year = new Date().getFullYear();

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white/95">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 sm:px-6">
          <div className="text-lg font-semibold tracking-tight">{t('public.geo_brand')}</div>
          <a
            href="mailto:support@lewouhmart.com"
            className="text-sm font-medium text-slate-600 hover:text-slate-900"
          >
            {t('public.geo_contact')}
          </a>
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-10 sm:px-6">
        <div className="w-full max-w-2xl rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{t('public.geo_title')}</h1>
          <p className="mt-3 text-sm text-slate-600">{t('public.geo_body')}</p>
          {country ? (
            <p className="mt-4 text-xs text-slate-500">
              {t('public.geo_country')} <span className="font-mono">{country}</span>
            </p>
          ) : (
            <p className="mt-4 text-xs text-slate-500">{t('public.geo_unknown_country')}</p>
          )}
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-4 py-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>{t('public.geo_footer_rights', { year })}</p>
          <div className="flex items-center gap-4">
            <Link to="/legal" className="hover:text-slate-700">
              {t('public.geo_legal')}
            </Link>
            <Link to="/feedback" className="hover:text-slate-700">
              {t('public.geo_feedback')}
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
